import React, { useMemo, useState } from 'react';
import { Icon } from '@fasstech/middle-design-system';
import classNames from 'classnames';
import { isNotNilOrEmpty, mapIndexed } from '@@serverHelpers/index.mjs';

export const CardContent = ({ data, wrap }) => {
  const itemClassName = useMemo(
    () =>
      classNames(
        'm-2.5 border-separate border-spacing-y-3.5 text-primary-950 w-full grid grid-cols-1 md:grid-cols-2!',
        {
          'flex-wrap': wrap
        }
      ),
    [wrap]
  );

  return (
    <div className={itemClassName}>
      {mapIndexed(
        (item, index) => (
          <div key={item.label + '-' + index} className={'h-[36px] flex items-center py-2'}>
            <span
              className={`align-middle ${item.bold === false ? '' : 'font-bold'} w-32 leading-4 shrink-0`}>
              {item.label}
            </span>
            {item.badge && (
              <span className="text-primary-100 py-1 px-3.5 rounded-full border border-primary-100 font-bold m-2">
                {item.badge}
              </span>
            )}
            <span className={'font-medium grow pl-6 leading-4'}>{item.value}</span>
          </div>
        ),
        data
      )}
    </div>
  );
};

const CardContainer = ({
  icon,
  iconSize = 10,
  title,
  badge,
  data,
  wrap,
  expendable = false,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };
  return (
    <div className="border border-[#E8E8E8] rounded-md w-full min-w-[33%] h-fit">
      <div className="flex items-center p-2 border-b-1 border-b-[#E8E8E8] gap-4">
        <Icon name={icon} size={iconSize} fillCassName="fill-primary"></Icon>
        <span className="text-2xl font-bold text-primary">{title}</span>
        {badge && (
          <div
            className={
              'text-primary-200 bg-white py-0.5 px-2 rounded-full border border-primary text-xs leading-[18px] font-medium'
            }>
            {badge}
          </div>
        )}
        {expendable && (
          <button type="button" onClick={toggleExpand} className="ml-auto">
            <Icon
              name="up"
              size={6}
              className={classNames('transition-transform', {
                'rotate-180': isExpanded
              })}
            />
          </button>
        )}
      </div>
      {isExpanded &&
        (isNotNilOrEmpty(data) && !children ? <CardContent data={data} wrap={wrap} /> : children)}
    </div>
  );
};

export default CardContainer;
